<template>
  <b-modal
    :id="id"
    :ref="id"
    :title="title | i18n"
    :ok-title="'save' | i18n"
    :cancel-title="'Cancel' | i18n"
    ok-variant="primary"
    :ok-disabled="!data.name"
    cancel-variant="outline-secondary"
    button-size="lg"
    size="lg"
    centered
    content-class="rounded-8"
    @ok="save"
    @show="init"
    @hide="clear"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.name" form-group-id="name" placeholder="name" />
      </div>
    </div>
    <div class="row">
      <div class="col-11" v-if="data.file && isOne">
        <Input :value="data.file.name ? data.file.name : data.file" :viewMode="true" form-group-id="File" placeholder="File" />
      </div>
      <div class="col-1" v-if="data.file && isOne" style="padding: 0">
        <b-button
          v-b-tooltip.hover
          :title="'delete' | i18n"
          class="close float-none mr-3"
          aria-label="Close"
          variant="light"
          @click="data.file = null"
          style="margin-top: 40px"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12" v-if="!data.file && isOne">
        <FileInput v-model="data.file" form-group-id="file" placeholder="File" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12" v-if="isOne">
        <Checkbox v-model="data.isConfirmation" form-group-id="Confirmation Checkboxes required" placeholder="Confirmation Checkboxes required" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12" v-if="isOne">
        <Checkbox v-model="data.isFile" form-group-id="File upload " placeholder="File upload" />
      </div>
      <div class="translate-actions">
        <b-button variant="primary" size="sm" @click="addLanguage" :disabled="!languagesOptions.length">
          + {{ 'add_name_translation' | i18n }}
        </b-button>
        <b-button
          style="margin-right: 20px"
          variant="outline-primary"
          size="sm"
          @click="generateTranslation"
          :disabled="!data.name || !selectedLanguages.length"
        >
          {{ 'fill_in_the_fields_with_automatic_translation' | i18n }}
        </b-button>
      </div>
    </div>
    <span v-if="loaded">
      <div class="row" v-for="lng in selectedLanguages" :key="lng.id">
        <div class="col-lg-5 col-sm-5 col-xs-5">
          <Select
            v-model="lng.language"
            :options="lng.language ? [{ text: TRANSLATE_LANGUAGE_NAMES[lng.language], value: lng.language }, ...languagesOptions] : languagesOptions"
            form-group-id="Language"
            placeholder="Language"
          />
        </div>
        <div class="col-lg-5 col-sm-5 col-xs-5">
          <span v-if="!translated[lng.language].loaded">
            {{ 'Translating...' | i18n }}
          </span>
          <Input
            v-else
            :value="translated[lng.language].name"
            form-group-id="Translation"
            placeholder="Translation"
            :onChange="
              (e) => {
                onInputChange(lng.language, e);
              }
            "
          />
        </div>
        <div class="col-lg-2 col-sm-2 col-xs-2">
          <b-button
            v-b-tooltip.hover
            :title="'delete' | i18n"
            class="close float-none mr-3"
            aria-label="Close"
            variant="light"
            @click="() => deleteLanguage(lng.id)"
            style="margin-top: 40px"
          >
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
      </div>
    </span>
  </b-modal>
</template>

<script>
import Vue from 'vue';

import Input from '../../../../common/input';
import Checkbox from '../../../../common/checkbox';
import FileInput from '../../../../common/fileInput';
import Select from '../../../../common/select';

import { TRANSLATE_LANGUAGE } from '../../../../../../../../../constants';
import api from '../../../../../api/index';

export default {
  name: 'GroupName',
  components: { Input, Checkbox, FileInput, Select },
  props: {
    id: {
      type: String,
      default: null,
    },
    initData: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    isOne: {
      type: Boolean,
      default: false,
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      data: {
        name: '',
        isConfirmation: false,
        isFile: false,
        file: null,
        translation: {},
      },
      fileName: '',
      languages: [],
      selectedLanguages: [],
      TRANSLATE_LANGUAGE_NAMES: {},
      translated: {},
      loaded: false,
    };
  },
  computed: {
    selectedLanguagesKeys: function () {
      return this.selectedLanguages.map((i) => i.language);
    },
    languagesOptions: function () {
      return this.languages.filter((l) => !this.selectedLanguagesKeys.includes(l.value)).map((l) => ({ value: l.value, text: l.text }));
    },
  },
  methods: {
    async translate(lng, cb) {
      const translation = await api.translate.translate({ message: this.data.name, language: lng.language });
      cb(translation);
    },
    generateTranslation() {
      for (const index in this.selectedLanguages) {
        const lng = this.selectedLanguages[index];
        try {
          this.translated[lng.language].loaded = false;
          this.translate(lng, (translation) => {
            this.translated[lng.language] = {
              loaded: true,
              name: translation.data,
            };
          });
        } catch (e) {
          this.translated[lng.language] = {
            loaded: true,
            name: '',
          };
        }
      }
    },
    addLanguage() {
      this.selectedLanguages.unshift({ language: this.languagesOptions[0].value, translation: '', id: this.getID() });
    },
    deleteLanguage(id) {
      this.selectedLanguages = this.selectedLanguages.filter((i) => i.id !== id);
    },
    getID() {
      return `${Math.round(Math.random() * 10000)}_${new Date().getTime()}`;
    },
    init() {
      this.loaded = false;
      this.languages = Object.keys(TRANSLATE_LANGUAGE).map((key) => {
        this.TRANSLATE_LANGUAGE_NAMES[TRANSLATE_LANGUAGE[key]] = key;
        Vue.set(this.translated, TRANSLATE_LANGUAGE[key], {
          loaded: true,
          name: '',
        });
        return { text: key, value: TRANSLATE_LANGUAGE[key] };
      });
      this.selectedLanguages = [];
      if (this.initData) {
        const { name, isConfirmation, isFile, file, translation = {} } = this.initData;
        Object.keys(translation).map((key) => {
          this.translated[key].name = translation[key];
          this.selectedLanguages.push({ language: key, id: this.getID() });
        });
        this.data = {
          name,
          isConfirmation,
          isFile,
          file,
        };
      }
      console.log('this', this);

      this.loaded = true;
    },
    clear() {
      this.data = {
        name: '',
        isConfirmation: false,
        isFile: false,
        file: null,
        translated: {},
        selectedLanguages: [],
      };
    },
    onInputChange(key, val) {
      this.translated[key].name = val;
    },
    save() {
      const translation = {};
      this.selectedLanguages.map((l) => {
        const key = l.language;
        if (this.translated[key].name) {
          translation[key] = this.translated[key].name;
        }
      });

      console.log(translation, 'translation');
      this.onSubmit({
        ...this.data,
        translation,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.translate-actions {
  margin-bottom: 30px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-left: 15px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}

::v-deep .modal-footer {
  justify-content: space-between;
  padding: 1.5rem;
  padding-top: 0;
  border: none;
  & > button {
    padding-right: 135px;
    padding-left: 135px;
    margin: 0;
  }
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
